import React from 'react';
import { cn } from 'lib/utils';

export interface FilterSectionProps {
    children: React.ReactNode;
    className?: string;
}

const FilterSection: React.FC<FilterSectionProps> = ({ children, className = '' }) => {
    return (
        <div
            className={cn(
                'mb-4 flex flex-wrap items-center gap-2 rounded border border-border bg-card px-4 py-3',
                className
            )}
        >
            {children}
        </div>
    );
};

export default FilterSection;
